import { getDateByLastDays } from 'src/helpers';

export const NAME = 'property';
export const IDENTITY_VERIFICATION_FILTER = 'status=ACTIVE,identity_verification=enabled';

export const TIMEFRAME_OPTIONS = [
  { value: 'last_60_days', label: 'Last 60 days' },
  { value: 'last_30_days', label: 'Last 30 days', isSelected: true },
  { value: 'custom', label: 'Custom' }
];

export const IDENTITY_VERIFICATION_REPORT_IMAGE_TYPES = [
  { value: 'selfie', label: 'Selfie' },
  { value: 'document', label: 'Document' },
  { value: 'none', label: 'None' }
];

export const IDENTITY_VERIFICATION_PROVIDERS = [
  { value: 'incode', label: 'Incode' },
  { value: 'clear', label: 'CLEAR' }
];

export const defaultDate = getDateByLastDays(
  TIMEFRAME_OPTIONS.find((date) => date.isSelected)?.value
);
export const EMPTY_VALUE = '';

export const IDV_FLOW_TYPE = {
  BASIC: 'basic',
  ENHANCED: 'enhanced',
  LITE: 'lite',
  FULL: 'full',
  ENHANCED_CPN: 'enhanced_cpn'
} as const;

export type IdvConfiguredFlowType = typeof IDV_FLOW_TYPE.BASIC | typeof IDV_FLOW_TYPE.ENHANCED;

export type IdvWireFlowType =
  | typeof IDV_FLOW_TYPE.LITE
  | typeof IDV_FLOW_TYPE.FULL
  | typeof IDV_FLOW_TYPE.ENHANCED_CPN;

/**
 * Maps a configured flow type to the value EPA expects on the applicant link.
 * Shared so the copy-link and QR paths can never disagree.
 */
export const toWireFlowType = (
  type: IdvConfiguredFlowType,
  isCpnEnabled: boolean
): IdvWireFlowType => {
  if (type === IDV_FLOW_TYPE.BASIC) {
    return IDV_FLOW_TYPE.LITE;
  }
  return isCpnEnabled ? IDV_FLOW_TYPE.ENHANCED_CPN : IDV_FLOW_TYPE.FULL;
};

export const IDV_PROVIDER = {
  CLEAR: 'clear',
  INCODE: 'incode'
} as const;

export type IdvProvider = (typeof IDV_PROVIDER)[keyof typeof IDV_PROVIDER];

export const PROPERTY_FIELD = {
  // TODO: Remove once PropertyFormNew derives IDV state solely from property_features
  IDV_ENABLED: 'identity_verification_enabled',
  IDV_FLOW_TYPES: 'identity_verification_flow_types'
} as const;

export const IDV_LABEL = {
  BASIC: 'Basic',
  ENHANCED: 'Enhanced'
} as const;

export const UI_BUTTON_LABELS = {
  COPY_LINK: 'Copy Link',
  QR_CODE: 'QR Code'
} as const;

export const IDV_FLOW_TYPES_CHECKBOXES: ReadonlyArray<{
  value: IdvConfiguredFlowType;
  label: string;
  name: string;
}> = [
  { value: IDV_FLOW_TYPE.BASIC, label: IDV_LABEL.BASIC, name: 'idv-flow-basic' },
  { value: IDV_FLOW_TYPE.ENHANCED, label: IDV_LABEL.ENHANCED, name: 'idv-flow-enhanced' }
] as const;
